<template>
  <div class="form-body">
    <div class="row">
      <div class="col-12 col-md-6" v-show="!seizure._id">
        <div class="form-group">
          <label for="projectinput2"><span class="required">*</span>{{ $t("labels.patient") }}</label>
          <select class="form-control" @change="$emit('patientchanged')" v-model="seizure.patientId">
            <option v-for="patient in $store.state.patients" :value="patient._id" :key="patient._id">{{ patient.name }} {{ patient.surname }} {{ patient.default ? "( default )" : "" }} </option>
          </select>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <label for="occuredOn"><span class="required">*</span>{{ $t("labels.occuredOn") }}</label>
        <date-picker v-model="seizure.occuredOn" :lang="$i18n.locale" width="100%" type="datetime" :popupStyle="{top: 30, left: 0}" :format="$i18n.locale === 'en' ? 'DD/MM/YYYY hh:mm a' : 'DD/MM/YYYY HH:mm'" confirm></date-picker>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="projectinput4"><span class="required">*</span>{{ $t("labels.type") }}</label>
          <select class="form-control" v-model="seizure.type">
            <option v-for="tp in lovTypes" :value='`{"id":"${tp._id}","name":${JSON.stringify(tp.name)}}`' :key="tp._id">{{ tp.name[$i18n.locale] }}</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="projectinput4">{{ $t("labels.triggeringFactor") }}</label>
          <select class="form-control" v-model="seizure.triggeringFactor">
            <option selected value> -- select triggering factor -- </option>
            <option v-for="tp in triggeringFactors" :value='`{"id":"${tp._id}","name":${JSON.stringify(tp.name)}}`' :key="tp._id">{{ tp.name[$i18n.locale] }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput4"><span class="required">*</span>{{ $t("labels.duration") }}</label>
          <select class="form-control" v-model="seizure.duration">
            <option v-for="tp in durations" :value='`{"id":"${tp._id}","name":${JSON.stringify(tp.name)}}`' :key="tp._id">{{ tp.name[$i18n.locale] }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput4">{{ $t("labels.status") }}</label>
          <select class="form-control" v-model="seizure.status">
            <option value="awake" selected>{{ $t("labels.awake") }}</option>
            <option value="lazy" selected>{{ $t("labels.lazy") }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row bottom-space">
      <div class="col-md-6">
         <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="seizureBlocked" v-model="seizure.seizureBlocked">
            <label class="custom-control-label float-left" for="seizureBlocked" @click="seizure.modal == true ? seizure.seizureBlocked = !seizure.seizureBlocked : ''">{{ $t("labels.seizureBlocked") }}</label>
        </div>
      </div>
      <div class="col-md-6">
         <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="blockedWithDrugs" @change="checkDrugs(seizure.blockedWithDrugs)"  v-model="seizure.blockedWithDrugs">
            <label class="custom-control-label float-left" for="blockedWithDrugs" @click="seizure.modal == true ? seizure.blockedWithDrugs = !seizure.blockedWithDrugs : ''">{{ $t("labels.blockedWithDrugs") }}</label>
        </div>
      </div>
    </div>
    <div class="row" v-if="seizure.blockedWithDrugs">
      <div class="col-sm-8">
        <div class="form-group">
          <label for="seizureDrug">{{ $t("labels.lifeSavingDrug") }}</label>
          <list-select :list="drugs"
                     option-value="_id"
                     option-text="name"
                     :custom-text="drugName"
                     :selected-item="selectedDrug"
                     @select="onDrugSelect">
          </list-select>
          <span class="help-block" v-html=" $t('labels.drugNotPresentForSeizureText')">
          </span>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label for="seizureQuantity">{{ $t("labels.quantity") }}</label>
          <div class="input-group">
            <select id="selectedDrugQuantity" class="form-control" v-model="selectedDrugQuantity">
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-12 bottom-space">
        <button class="btn btn-success" @click.prevent="addDrug">{{ $t("labels.addDrug") }}</button>
      </div>
      <div class="col-md-12">
        <table class="table table-responsive-sm" v-if="seizure.drug && seizure.drug.length > 0">
          <thead>
            <th>
              {{ $t("labels.drug") }}
            </th>
            <th>
              {{ $t("labels.quantity") }}
            </th>
            <th>
              {{ $t("labels.actions") }}
            </th>
          </thead>
          <tbody>
            <tr v-for="d in seizure.drug" :key="d.id">
              <td>
                {{ d.name[$i18n.locale] ? d.name[$i18n.locale] : d.name['en'] }}
              </td>
              <td>
                {{ d.quantity }}
              </td>
              <td>
                  <a class="warning p-0" @click.prevent="removeDrug(d)">
                      <i class="fa fa-trash font-medium-3 mr-2"></i>
                  </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row bottom-space">
      <div class="col-md-12 bottom-space">
         <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="hospitalization" v-model="seizure.hospitalization">
            <label class="custom-control-label float-left" for="hospitalization" @click="seizure.modal == true ? seizure.hospitalization = !seizure.hospitalization : ''">{{ $t("labels.hospitalization") }}</label>
        </div>
      </div>
    </div>
    <div class="row bottom-space">
      <div class="col-md-6">
        <div class="input-group">
          <div class="dropzone bottom-space">
            <h5>
              {{ $t("labels.video") }}
              <span><strong>{{ $t('labels.maxVideoSize') }}:</strong><br>50 Mb</span>
              <span><strong>{{ $t('labels.allowedFormats') }}:</strong><br>{{ $store.state.allowedVideoTypesSimple.toString().split(',').join(', ') }}</span>
            </h5> <br>
            <input type="file" id="video" ref="video" @change="getVideo">
          </div>
          <div class="row" v-if="video.name">
              <div class="col-md-10">
                <span><strong>{{ $t('labels.name') }}:</strong> {{ video.name }}</span> <br />
                <span :class="{red: video.size/1024/1024 > 50}"><strong>{{ $('labels.size') }}:</strong> {{ Math.round(video.size/1024/1024) }} Mb</span> <br />
                <span :class="{red: !$store.state.allowedVideoTypes.includes(video.type)}"><strong>{{ $t('labels.type') }}:</strong> {{ video.type }}</span>
              </div>
              <div class="col-md-2">
                <a class="warning p-0" @click.prevent="deleteVideo"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
              </div>
          </div>
          <div class="videoPlayer" v-if="seizure.video && seizure.video[0] && seizure.video[0].originalname">
            <h5><strong>{{ $t("labels.currentVideo") }}</strong></h5>
            <video width="100%" height="auto" controls ref="videopreview">
              <source :src="seizure.video[0].signed_url" :type="seizure.video[0].mimetype">
              Your browser does not support the video tag.
            </video>
            <p><strong>{{ seizure.video[0].originalname }}</strong></p>
            <a :href="seizure.video[0].signed_url" class="btn btn-success">Download video</a>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="input-group">
          <div class="dropzone">
            <h5>
              {{ $t("labels.image") }}
              <span><strong>{{ $t('labels.maxImageSize') }}:</strong><br>5 Mb</span>
              <span><strong>{{ $t('labels.allowedFormats') }}:</strong><br>{{ $store.state.allowedImageTypesSimple.toString().split(',').join(', ') }}</span>
            </h5>
            <input type="file" multiple id="image" ref="image" @change="getImage">
          </div>
        </div>
        <div class="row bottom-space selectedImages">
          <div class="col-md-6" v-for="(img, index) in images" :key="index">
            <figure>
              <img :src="getUrl(img)" alt="index">
              <figcaption>
                <span><strong>{{ $t('labels.name') }}:</strong> {{ img.name }}</span> <br />
                <span :class="{red: img.size/1024/1024 > 5}"><strong>Size:</strong> {{ Math.round(img.size/1024) }} Kbyte</span> <br />
                <span :class="{red: !$store.state.allowedImageTypes.includes(img.type)}"><strong>Type:</strong> {{ img.type }}</span>
              </figcaption>
              <a class="warning p-0" @click.prevent="deleteImage(img,index)"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
            </figure>
          </div>
        </div>
        <h5 v-if="seizure.image && seizure.image.length > 0"><strong>Uploaded images:</strong></h5>
        <div class="row bottom-space" v-if="seizure.image && seizure.image.length > 0">
          <div class="col-md-6" v-for="(img, index) in seizure.image" :key="index">
            <a :href="img.signed_url" download>
              <figure>
                <img :src="img.signed_url" :alt="img.originalname" style="max-width: 100%">
                <figcaption>Click image to download</figcaption>
              </figure>
            </a>
            <p>
              <a class="warning p-0" @click.prevent="deleteImageFromServer(img,index)"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row bottom-space">

    </div>
    <div class="row bottom-space">
      <div class="col-md-12">
        <label for="projectinput4">{{ $t("labels.notes") }}</label>
        <ckeditor :editor="editor" v-model="seizure.notes" :config="editorConfig" ref="snotes"></ckeditor>
      </div>
    </div>
  </div>
</template>

<script>
import LovService from '@/services/lov'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { ListSelect } from 'vue-search-select'
import moment from 'moment'

export default {
  props: ["seizure"],
  components: {
    ListSelect
  },
  data() {
      return {
        placeholder: 'Seizure notes',
        drugs: [],
        lovTypes: [],
        triggeringFactors: [],
        durations: [],
        video: '',
        images: [],
        selectedDrugQuantity: null,
        selectedDrug: null,
        editor: ClassicEditor,
        editorData: '<p>Content of the editor.</p>',
        editorConfig: {
          toolbar: {
            items: [
              'bold',
              'italic',
              'bulletedList',
              'undo',
              'redo'
            ]
          }
        }
      }
  },
  methods: {
    alertMe() {
      alert('Hello')
    },
    nullifyEditor() {
      this.seizure.notes = ''
    },
    checkDrugs(bwd) {
      console.log('changed')
      if (bwd) {
        if (this.seizure.drug && this.seizure.drug.length === 0) {
          this.seizure.drug = []
        }
      }
    },
    drugName(drug) {
      return drug.name[this.$i18n.locale] ? drug.name[this.$i18n.locale] : drug.name['en']
    },
    getVideo() {
      if (this.$refs.video.files.length > 0) {
        this.video = this.$refs.video.files[0]
        this.seizure.video = this.$refs.video.files[0]
      }
    },
    getImage() {
      const images = this.$refs.image.files
      this.images = [ ...this.images, ...images ]
      this.seizure.uploadImages = this.images
    },
    deleteImage(img,index) {
      this.images.splice(index, 1)
    },
    deleteImageFromServer: async function(img,index) {
      this.$emit('imagedeleted', { 'index': index, 'img': img  })
    },
    deleteVideo() {
      this.$refs.video.value = ''
      this.video = {}
      delete this.seizure.video
    },
    getFiles() {
      let images = this.$refs.newSeizureImageZone.getAcceptedFiles()
    },
    getUrl(img) {
      return URL.createObjectURL(img)
    },
    resetFiles() {
      this.video = ''
      this.images = []
    },
    onDrugSelect(drug) {
      this.selectedDrug = drug
    },
    addDrug() {
      console.log(this.selectedDrug)
      if (this.selectedDrug != null) {
        let item = {
          'id': this.selectedDrug._id,
          'name': this.selectedDrug.name,
          quantity: this.selectedDrugQuantity
        }
        this.seizure.drug.push(item)
      } else {
        this.$miniToastr.error(this.$t("errors.invalidLifesavingDrug"))
      }
    },

    removeDrug(e) {
      this.seizure.drug = this.seizure.drug.filter(function(d) {
                                                return d.id !== e.id
                                            })
    },
    myText(e) {
      return e
    }
  },
  watch: {
    seizure: function(value) {
      //this.editor.setContent(value.notes)
      if (this.$refs.videopreview) {
        this.$refs.videopreview.load()
      }
    }
  },
  mounted: async function() {
    let drugs = await LovService.all('life_saving_drug', false)
    if (drugs) {
      this.drugs = drugs.data
    }
    let lovTypes = await LovService.all('seizure', false)
    if (lovTypes) {
      this.lovTypes = lovTypes.data
    }
    let triggeringFactors = await LovService.all('triggering_factor', false)
    if (triggeringFactors) {
      this.triggeringFactors = triggeringFactors.data
    }
    let durations = await LovService.all('duration', false)
    if (durations) {
      this.durations = durations.data
    }
  }
}
</script>

<style lang="scss">
  .dropzone {
    width: 100%;
    background-color: #eee;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    outline: 2px dashed #eee;
    outline-offset: 5px;
    border: none;
    transition: all .5s ease;

    h5 {
      padding: 15px;
      text-align: center;
      max-width: 90%;

      span {
        margin-top: 15px;
        display: block;
        font-size: 12px;

        strong {
          text-transform: uppercase;
        }
      }
    }

    &:hover {
      background-color: darken(#eee,10%);
      outline: 2px dashed darken(#eee,10%)
    }

    input {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }

  .selectedImages {
    img {
      max-width: 200px;
      max-height: 200px;
    }
  }
  .ck-editor__editable {
    min-height: 150px;
  }
  .red {
    color: red;
  }
</style>

